import "./app.css";

import { setApiErrorCallback } from "@poolsideai/api";
import { init } from "@poolsideai/assistant";
import * as Sentry from "@sentry/svelte";
import { mount, type Component } from "svelte";
import { envStore } from "./lib/env/store";

// Set up the syntax highlighter and load the env before rendering the app. If the env declares
// a BASE_URI then we need to know this before we configure the app router otherwise visiting a URL
// on the page directly won't cause a route hit.
Promise.all([init(), envStore.load()]).then(async ([, env]) => {
  if (env?.SENTRY_DSN) {
    Sentry.init({
      dsn: env.SENTRY_DSN,
      release: __BUILD_COMMIT__ || undefined,
      sendDefaultPii: true,
    });

    setApiErrorCallback((error, url) => {
      if (error.status >= 500) {
        Sentry.captureException(error, {
          tags: {
            api_url: url,
            status_code: error.status.toString(),
          },
          extra: {
            request_id: error.request_id,
            response_body: error.body,
          },
        });
      }
    });
  }

  // Static-condition dynamic import: Vite replaces __APP_TYPE__ with a literal at
  // build time, so Rollup sees `if ("cloud" === "cloud")` or its inverse, and
  // tree-shakes the dead branch including the entire imported module's transitive graph.
  let RootApp: Component;
  if (__APP_TYPE__ === "cloud") {
    RootApp = (await import("./lib/CloudApp.svelte")).default;
  } else {
    RootApp = (await import("./lib/App.svelte")).default;
  }

  mount(RootApp, { target: document.getElementById("app")! });
});
